import React from "react";
import DatePicker, {registerLocale} from "react-datepicker";
import pl from "date-fns/locale/pl";

registerLocale("pl", pl);

const QTimePicker = ({
  pickerId,
  errorParagraphId,
  state,
  propertyName,
  startTime,
  setStartTime,
  caption,
  commitToState = true
}) => {
  const formatDateToTimeString = (date) => {
    if (!date) return null;
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };

  const parseTimeToDate = (timeString) => {
    if (!timeString) return null;
    if (typeof timeString === 'string') {
      const [hours, minutes] = timeString.split(':').map(Number);
      return new Date(1970, 0, 1, hours || 0, minutes || 0, 0);
    }
    if (timeString instanceof Date) return timeString;
    throw new Error('Invalid time format');
  };

  const setErrorVisible = (visible) => {
    const element = document.getElementById(errorParagraphId);
    if (!element) return;
    element.classList.toggle('offscreen', !visible);
  };

  const markChanged = () => {
    state?.setItemChanged?.((prev) => !prev);
    state?.setCurrentFormState?.((prev) => ({...prev, formSaveButtonDisabled: false}));
  };

  const commitValue = (timeString) => {
    if (!commitToState) return;
    state?.setCurrentItem?.((prev) => ({...prev, [propertyName]: timeString}));
  };

  const handleTimeChange = (time) => {
    if (!time) {
      setStartTime(null);
      commitValue(null);
      if (commitToState) markChanged();
      setErrorVisible(false);
      return;
    }

    const parsed = time instanceof Date ? time : parseTimeToDate(time);
    const timeString = formatDateToTimeString(parsed);
    setStartTime(parseTimeToDate(timeString));
    commitValue(timeString);
    if (commitToState) markChanged();
    setErrorVisible(false);
  };

  const handleRawChange = (e) => {
    const value = e.target.value;
    const timeRegex = /^([01]?\d|2[0-3]):[0-5]\d$/;

    if (!timeRegex.test(value)) {
      setErrorVisible(true);
      return;
    }

    const parsedTime = parseTimeToDate(value);
    setStartTime(parsedTime);
    commitValue(formatDateToTimeString(parsedTime));
    if (commitToState) markChanged();
    setErrorVisible(false);
  };

  return (
    <DatePicker
      locale="pl"
      id={pickerId}
      selected={startTime}
      onChange={handleTimeChange}
      onChangeRaw={handleRawChange}
      showTimeSelect
      showTimeSelectOnly
      timeFormat="HH:mm"
      timeIntervals={15}
      dateFormat="HH:mm"
      timeCaption={caption}
      autoComplete="off"
    />
  );
};

export default QTimePicker;
